import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, ConfirmationModal, Typography } from 'seagull';
import { NewTab } from 'seagull/icons';
import { CopyToClipboard } from '~/components/CopyToClipboard/CopyToClipboard';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { openInNewTabProps, routes } from '~/constants';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useOnMount } from '~/hooks/useOnMount';
import styles from './CopyAPIKeyModal.module.scss';
import { getIntegrationSteps } from './integrationSteps';
export default function CopyAPIKeyModal(param) {
    let { dismissModal, slug, title, integrationUrl, getApiKey, onCopyApiKey } = param;
    const [apiKey, setApiKey] = useState('');
    const [helperText, setHelperText] = useState('');
    const { MANAGE_API_KEYS } = useFeatureFlags();
    useOnMount(()=>{
        if (!MANAGE_API_KEYS) {
            getApiKey().then(setApiKey).catch(()=>setHelperText('API key not found. Please try again later.'));
        }
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: "Integrate with ".concat(title),
        width: "760px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.modalContainer,
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    children: [
                        "To integrate with ",
                        title,
                        ", follow the next steps: "
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.stepsContainer,
                    children: MANAGE_API_KEYS ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                children: [
                                    "1. Go to the",
                                    ' ',
                                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                                        href: routes.anchorApiKeys,
                                        underline: "none",
                                        openInNewTab: true,
                                        children: "Anchor API Keys"
                                    }),
                                    ' ',
                                    "page and generate a new API key for ",
                                    title,
                                    "."
                                ]
                            }),
                            getIntegrationSteps(slug)
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "1. Copy the API key below"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.copyApiKeyContainer,
                                children: /*#__PURE__*/ _jsx(CopyToClipboard, {
                                    testId: "".concat(slug, "-api-key"),
                                    value: apiKey,
                                    helperText: helperText,
                                    error: !!helperText,
                                    onClick: onCopyApiKey
                                })
                            }),
                            getIntegrationSteps(slug)
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(Button, _object_spread_props(_object_spread({
                    skin: "primaryOutline",
                    testId: "go-to-".concat(slug),
                    as: "a",
                    suffixIcon: /*#__PURE__*/ _jsx(NewTab, {}),
                    href: integrationUrl
                }, openInNewTabProps), {
                    className: styles.goToContainer,
                    children: [
                        "Go to ",
                        title
                    ]
                }))
            ]
        }),
        primaryButtonLabel: "Close",
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        testId: "integrate-with-".concat(slug, "-modal")
    });
}
